import React, { useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/pro-regular-svg-icons';
import { getLang } from 'shared/store/selectors/lang.selector';
import { ColumnChooser } from './column-chooser';
import styles from './column-chooser-button.module.scss';
import { IconButton } from '../../buttons';

/**
 * Floating column chooser button for the top-right corner of the table
 * @param {{ api: import('ag-grid-community').GridApi }} props
 */
export function ColumnChooserButton({ api }) {
  const lang = useSelector(getLang('FILTERS'));
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const containerRef = useRef(null);

  const getPopupContainer = useCallback(() => containerRef.current, []);

  const handleToggle = useCallback(() => {
    setOpen(prev => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    buttonRef.current?.focus();
  }, []);

  // Handle clicking outside to close
  const handleOpenChange = useCallback(newOpen => {
    if (!newOpen) {
      setOpen(false);
    }
  }, []);

  if (!api) {
    return null;
  }

  return (
    <div ref={containerRef} className={styles.root}>
      <Popover
        content={<ColumnChooser api={api} onClose={handleClose} isOpen={open} />}
        open={open}
        onOpenChange={handleOpenChange}
        placement="bottomLeft"
        arrow={false}
        destroyOnHidden
        getPopupContainer={getPopupContainer}
        classNames={{ root: styles.popover, container: styles.popoverContainer }}>
        <IconButton
          ref={buttonRef}
          className={styles.button}
          label={lang.COLUMN_SETTINGS}
          onClick={handleToggle}>
          <FontAwesomeIcon icon={faGear} className={styles.icon} />
        </IconButton>
      </Popover>
    </div>
  );
}
